/**
 * Typography component themable props.
 */
import { stringLiteralArray } from "../utils"
import { whiteSpaceValues } from "../whiteSpace"

export default {
  appearances: stringLiteralArray([
    "title1",
    "title2",
    "title3",
    "title4",
    "title5",
    "title6",
    "subtitle1",
    "subtitle2",
    "subtitle3",
    "body1",
    "body2",
    "body3",
    "caption",
    "overline",
    "label"
  ]),
  whiteSpaceValues
}
